// Exhibitions slider, which is also just image slider.
const $ = jQuery;
const $window = $(window);

const initSlider = () => {
  const els = once('exhibition-slider', '.p-exhibition-slider');
  els.forEach((el) => {
    const $wrapper = $(el);
    const $slider = $wrapper.find('.pes-slider');

    // get current slide number and display under slider on mobile
    // (format eg: 1 of 5)
    $slider.on(
      'init reInit afterChange',
      function handleResize(event, slick, currentSlide) {
        const currentSlideNum = (currentSlide || 0) + 1;
        $wrapper
          .find('.om-slider-count')
          .text(`${currentSlideNum} of ${slick.slideCount}`);
      },
    );

    // Slick initialization
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      infinite: true,
      accessibility: true,
      pauseOnHover: true,
      autoplaySpeed: 3000,
      prevArrow: $wrapper.find('.om-slider-arrow-prev'),
      nextArrow: $wrapper.find('.om-slider-arrow-next'),
      appendDots: $wrapper.find('.om-slider-dots'),
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
};

$window.on('load', () => initSlider());
